import { useQuery} from '@tanstack/react-query'
import api from '../api';
import React, { useState, useEffect } from 'react';
import Question from "./Question";
import Lottie from 'react-lottie-player';
import loadingAnimation from '../animations/loading.json';
import AddCustomQuestion from './AddCustomQuestion';
import Loader from './Loader';

export default function Questions({randomId, storedData, jobTitle, jobDescription, setStoredData, setStep}) {
    const [selectedHardQuestions, setSelectedHardQuestions] = useState([]);
    const [selectedSoftQuestions, setSelectedSoftQuestions] = useState([]);
    const [allHardSelected, setAllHardSelected] = useState(false);
    const [allSoftSelected, setAllSoftSelected] = useState(false);
    const [hardQuestions, setHardQuestions] = useState([]);
    const [softQuestions, setSoftQuestions] = useState([]);
    const [spinner, setSpinner] = useState(false);
    const [isLoading, setIsLoading] = useState(false);

    const { isError, data, error, refetch } = useQuery(
		['getQuestions'], 
		() => api.getQuestions(jobTitle, jobDescription, storedData?.selectedHardSkills , storedData?.selectedSoftSkills), 
        {
            enabled: false,
            onSuccess: data => {
                mapQuestions(data.soft, data.hard);
               setIsLoading(false);
            }
        }
	)
    const mapQuestions = (softQuestions, hardQuestions) => {
        const soft = softQuestions.map((item, index) => {
            return {
                id: Math.floor(Math.random() * 100000),
                question: item.question,
                skills: item.skills,
                type: "soft",
            }
        });
        const hard = hardQuestions.map((item, index) => {
            return {
                id: Math.floor(Math.random() * 100000),
                question: item.question,
                skills: item.skills,
                type: "hard",
            }
        });
        setSoftQuestions(soft);
        setHardQuestions(hard);

        const tmp = { ...storedData };
        tmp.softQuestions = soft;
        tmp.hardQuestions = hard;
        localStorage.setItem(randomId, JSON.stringify(tmp));
        setStoredData(tmp);
    }
    const addQuestion = (item) =>{
        if(item.type === "hard"){
            setSelectedHardQuestions(prevQs => [...prevQs, item]);  
        }else{
            setSelectedSoftQuestions(prevQs => [...prevQs, item]);
        }
    }
    const removeQuestion = (question) =>{
        if(question.type === "hard"){
            setSelectedHardQuestions(prevQs => prevQs.filter(( item, i) => item.id !== question.id));
        }else{
            setSelectedSoftQuestions(prevQs => prevQs.filter(( item, i) => item.id !== question.id));
        }
    }
    const summarize = (e) => {
        e.preventDefault();
        const d = { ...storedData };
        d.selectedSoftQuestions = selectedSoftQuestions;
        d.selectedHardQuestions = selectedHardQuestions;
        localStorage.setItem(randomId, JSON.stringify(d));
        setStoredData(d);
        setStep('summary');
    }
    const addCustomQuestion = (type, text) => {
        const question = {
            id: Math.floor(Math.random() * 100000),
            question: text,
            type: type,
            skills: [],
        }
        if (type === "hard") {
            setHardQuestions([
                ...hardQuestions, ...[question]
            ])
        } else {
            setSoftQuestions([
                ...softQuestions, ...[question]
            ])
        }
    }
    useEffect(() => {
        isLoading === false && setSpinner(!spinner)
    }, [isLoading]);

    useEffect(() => {
        if (!jobTitle) {
            return;
        }
        if (storedData?.softQuestions?.length === 0) {
            setIsLoading(true);
            refetch();
        } else {
            mapQuestions(storedData.softQuestions, storedData.hardQuestions);
        }
    }, [jobTitle]) 
    return (
        <div className="page">
            {isLoading &&
                <div className='text__center'>
                    <Lottie
                        loop
                        animationData={loadingAnimation}
                        play
                        style={{ width: 250, height: 250, margin: 'auto' }}
                    />
                    <h3>
                        The AI is creating the best questions to test for the <div className="text__primary text__bold font__30">{jobTitle}</div> position based on the skills you selected.
                    </h3>
                    <Loader />
                </div>
            }
            { isError &&
                console.log("No Data")
            }
            {!isLoading && !isError && 
            <div className="flex flex-col mt-[50px]  h-[100vh] w-[100%`]">
                <div className="flex flex__row align--center">
                    <div className="btn btn__secondary" onClick={() => setStep('skills')}>
                        <span className='material-icons'>
                            arrow_back_ios
                        </span>
                        Back
                    </div>
                    <h4 className='text__success'>
                        Generated Questions for: {jobTitle}
                    </h4>
                </div>
                <form method="post" className='' onSubmit={summarize}>
                    <div className='card card__rounded'>
                        <div>
                            <h4 className='text__primary'>Pick Hard Questions</h4>
                            <div className="btn btn__success btn__md">
                                {selectedHardQuestions.length} selected
                            </div>
                        </div>
                        <div className="select__all">
                            <div>
                                <input
                                    type="checkbox"
                                    checked={allHardSelected}
                                    value="select all"
                                    onChange={(e) => setAllHardSelected(e.target.checked)}
                                    className='switch'
                                />
                                <span className="mleft--10">Select All</span>
                            </div>
                            <div className="btn btn__primary-soft btn__md">
                                {selectedHardQuestions.length}
                            </div>
                        </div>
                        <hr className="mtop--10 mbottom--10" />
                        {
                            hardQuestions.map((dt, index) => (
                                <div className="mtop--10" key={`hard_questions${index}`}>
                                    <Question question={dt} isChecked={allHardSelected} add={addQuestion} remove={removeQuestion} />
                                </div>
                            ))
                        }
                        <AddCustomQuestion type="hard" addCustomQuestion={addCustomQuestion} />
                    </div>
                    <div className='card card__rounded'>
                        <div>
                            <h4 className='text__primary'>Pick Soft Questions</h4>
                            <div className="btn btn__success btn__md">
                                {selectedSoftQuestions.length} selected
                            </div>
                        </div>
                        <div className="select__all">
                            <div>
                                <input
                                    type="checkbox"
                                    checked={allSoftSelected}
                                    value="select all"
                                    onChange={(e) => setAllSoftSelected(e.target.checked)}
                                    className='switch'
                                />
                                <span className="mleft--10">Select All</span>
                            </div>
                            <div className="btn btn__primary-soft btn__md">
                                {selectedSoftQuestions.length}
                            </div>
                        </div>
                        <hr className="mtop--10 mbottom--10" />
                        {
                            softQuestions.map((dt, index) => (
                                <div className="mtop--10" key={`soft_questions${index}`}>
                                    <Question  question={dt} isChecked={allSoftSelected} add={addQuestion} remove={removeQuestion} />
                                </div>
                            ))
                        }
                        <AddCustomQuestion type="soft" addCustomQuestion={addCustomQuestion} />
                    </div>
                    <button className="btn btn__primary btn__100 btn__rounded">
                        Continue with <b>{selectedHardQuestions.length + selectedSoftQuestions.length}</b> selected questions
                    </button>
                </form>
            </div> 
        }
    </div>
    )
}